import { render, staticRenderFns } from "./RatingsHeader.vue?vue&type=template&id=0a11b76b"
import script from "./RatingsHeader.vue?vue&type=script&lang=js"
export * from "./RatingsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports